// extracted by mini-css-extract-plugin
export default {"root":"YAoR_BiTtc9UPsO1VLBl","disabled":"tuzhWFERjSvngHs2ehUK","placeHolderShimmer":"HAoHVJKdTLGb2eQWi8_K"};